import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'hh-health-charts-widget',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './health-charts-widget.component.html',
  styleUrls: ['./health-charts-widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HealthChartsWidgetComponent {}
